import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Combines Tailwind CSS classes with clsx for conditional class handling
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get the current time for a specific city, ignoring device timezone.
 * Yerevan: UTC+4, Moscow: UTC+3.
 *
 * Pass `nowMs` (e.g. the server-synced clock from lib/server-clock.ts via
 * getServerNow()) to also correct for a wrong device *clock* — not just a
 * wrong device timezone. Defaults to Date.now() for callers that only need
 * timezone neutralization.
 */
export function getCityTime(city: "Yerevan" | "Moscow", nowMs: number = Date.now()): Date {
  const now = new Date(nowMs)
  const utcTime = new Date(now.getTime() + (now.getTimezoneOffset() * 60000))

  if (city === "Moscow") {
    // Moscow time: UTC+3
    return new Date(utcTime.getTime() + (3 * 60 * 60 * 1000))
  } else {
    // Yerevan time: UTC+4
    return new Date(utcTime.getTime() + (4 * 60 * 60 * 1000))
  }
}
